// extracted by mini-css-extract-plugin
export var buildCareerWrapper = "BuildCareer-module--buildCareerWrapper--mhRUL";
export var careerImage = "BuildCareer-module--careerImage--XsGl7";
export var contentContainer = "BuildCareer-module--contentContainer--XfKXv";
export var ctaContainer = "BuildCareer-module--ctaContainer--gyBXk";
export var description = "BuildCareer-module--description--nfGs3";
export var imageContainer = "BuildCareer-module--imageContainer--7jj4E";
export var title = "BuildCareer-module--title--GsRjl";